import { useMemo } from "react";
import { getApiErrorMessage } from "../utils/apiResponse";
import { usePublicPage } from "./usePublicPage";

export const usePublicPageSection = (slug, sectionKey, buildModel) => {
  const query = usePublicPage(slug);

  const result = useMemo(() => {
    if (!query.data) {
      return { model: null, sectionError: null };
    }

    try {
      const section = query.data.sections?.find((s) => s.key === sectionKey);
      if (!section) {
        throw new Error(
          `Section "${sectionKey}" was not found on the ${slug} page.`
        );
      }

      return { model: buildModel(section), sectionError: null };
    } catch (err) {
      return {
        model: null,
        sectionError: err instanceof Error ? err.message : String(err),
      };
    }
  }, [query.data, sectionKey, slug, buildModel]);

  const error =
    query.error != null
      ? getApiErrorMessage(query.error)
      : result.sectionError;

  return {
    model: result.model,
    error,
    isLoading: query.isPending && !result.model,
    isFetching: query.isFetching,
  };
};
